import React, { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import {
  Plus,
  Trash2,
  RotateCcw,
  Check,
} from "feather-icons-react/build/IconComponents";
import "../../../style/css/sales-invoice-terminal.css";
import {
  useTerminalChrome,
  TermCmdBar,
  TermMoreToggle,
  TermColumns,
  TermStatusBar,
} from "../terminal/TerminalChrome";
import toast from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";


import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import {
  getStockTransferByBranch,
  addEditStockTransfer,
} from "../../../services/StockApiServices";

import {
  fetchUnit,
  fetchProduct,
  fetchSettings,
} from "../../../redux/userSetting";
import { InvStockTransfer } from "../../../core/json/InvStockTransfer";
import { getWareHouseList } from "../../../services/MasterApiServices";


const StockTransferModal = ({ mode, data, handleClose, handleRefresh }) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    reset,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      date: dayjs().format("YYYY-MM-DD"),
    },
  });

  const [unitData, setunitData] = useState([]);
  const [products, setProducts] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);
  const dispatch = useDispatch();
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const { formatedproductList } = useSelector((state) => state.usersetting);
  const { BranchByUser } = useSelector((state) => state.userBranch);
  const [loading, setloading] = useState(false);
const [warehouses, setWarehouses] = useState([]);

    const { branchsettings } = useSelector((state) => state.settings);



  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });
  const { productList, unitList, settingList } = useSelector(
    (state) => state?.usersetting
  );


  useEffect(() => {
    dispatch(fetchUnit());
    dispatch(fetchProduct(branch));
    dispatch(fetchSettings(branch));
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
  }, [branch]);
  
     useEffect(() => {
              const fetchWarehouses = async () => {
                try {
               const response = await getWareHouseList();
            
                    setWarehouses(response);
                  
                } catch (err) {
                  console.error("Failed to fetch warehouses:", err);
                }
              };
              fetchWarehouses();
            }, []);

// Prefill From Warehouse based on branch settings

// useEffect(() => {
//   if (warehouses?.length > 0 && branchsettings?.defaultWareHouseID) {
//     const defaultWH = warehouses.find(
//       (wh) => wh.value === branchsettings.defaultWareHouseID
//     );
//     console.log("Default Warehouse:", defaultWH);
//     if (defaultWH) {
//       setValue("fromWarehouse", defaultWH.value);
//     }
//   }
// }, [warehouses, branchsettings]);
       const formattedWarehouses = Array.isArray(warehouses)
            ? warehouses.map((warehouse) => ({
                label: warehouse.name || "Unnamed Warehouse",
                value: warehouse,
              }))
            : [];
  // Helper function to get selected warehouse option
          // const getSelectedWarehouseOption = (warehouse) => {
          //   if (!warehouse) return null;
          //   return (
          //     formattedWarehouses.find((wh) => wh.value.guid === warehouse.guid) || {
          //       label: warehouse.name || "Select Warehouse",
          //       value: warehouse,
          //     }
          //   );
          // };

//           const getSelectedWarehouseOption = (warehouse) => {
//   if (!warehouse) return null;

//   // If warehouse is the exact object from options
//   const match = formattedWarehouses.find((wh) => wh.value.guid === warehouse.guid);
//   return match || { label: warehouse.name || "Select Warehouse", value: warehouse };
// };


// const getDefaultWarehouse = () => {
//   if (!branchsettings?.defaultWareHouseID || !warehouses?.length) return null;
//   const wh = warehouses.find((w) => w.guid === branchsettings.defaultWareHouseID);
//   return wh ? getSelectedWarehouseOption(wh) : null;
// };
// console.log("Default Warehouse:", getDefaultWarehouse());

// Filter warehouses by branch
const getWarehousesByBranch = (branchGuid) => {
  if (!warehouses?.length || !branchGuid) return [];
  return warehouses
    .filter((wh) => wh.branchID === branchGuid)
    .map((wh) => ({
      label: wh.name || "Unnamed Warehouse",
      value: wh,
    }));
};

// Helper for selected warehouse in react-select
// const getSelectedWarehouseOption = (warehouse, branchGuid) => {
//   if (!warehouse || !branchGuid) return null;
//   const filtered = getWarehousesByBranch(branchGuid);
//   const match = filtered.find((wh) => wh.value.guid === warehouse.guid);
//   return match || { label: warehouse.name || "Select Warehouse", value: warehouse };
// };
const getSelectedWarehouseOption = (warehouse, branchGuid) => {
  if (!warehouse || !branchGuid) return null;
  const filtered = getWarehousesByBranch(branchGuid);
  const match = filtered.find((wh) => wh.value.guid === warehouse.guid);
  return match || { label: warehouse.name || "Select Warehouse", value: warehouse };
};


// Default warehouse for branch
const getDefaultWarehouse = (branchGuid) => {
  const filtered = warehouses?.filter((w) => w.branchID === branchGuid);
  if (!filtered?.length || !branchsettings?.defaultWareHouseID) return null;
  const defaultWH = filtered.find(
    (wh) => wh.guid === branchsettings.defaultWareHouseID
  );
  return defaultWH ? getSelectedWarehouseOption(defaultWH, branchGuid) : null;
};


  const handleBranchList = async () => {
    try {
      const formattedBranch = BranchByUser?.map((obj) => ({
        label: obj?.branch?.name,
        value: obj?.branch?.guid,
      }));

      setBranchData(formattedBranch);
    } catch (error) {
      console.error(
        "Error fetching unit",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  const handleUnitList = async () => {
    try {
      const formattedUnit = unitList?.map((unit) => ({
        label: unit?.name,
        value: unit?.guid,
      }));
      setunitData(formattedUnit);
    } catch (error) {
      console.error(
        "Error fetching unit",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleEachProductfetch = async (selectedOption, index) => {
    setValue(`items[${index}].product`, selectedOption.value);

    try {
      const productData = await getSingleProduct(selectedOption.value);

      setValue(`items[${index}].code`, productData?.code || 0);
      setValue(`items[${index}].batch`, productData?.batch || 0);
      setValue(`items[${index}].unit`, productData?.unit || 0);
      setValue(`items[${index}].price`, productData?.cost || 0);
    } catch (error) {
      console.error(
        "Error fetching product by GUID:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  async function getSingleProduct(guid) {
    try {
      const filteredData = productList?.find(
        (product) => product.guid === guid
      );
      return filteredData;
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  }

  // Fetch purchase invoices data
  const handleEntryNo = async () => {
    try {
      const response = await getStockTransferByBranch(branch);
      const stockData = response || [];

      const maxno =
        stockData?.length > 0
          ? stockData
              .map((data) => parseInt(data?.invoiceNo.replace(/\D/g, "")))
              .reduce((max, num) => Math.max(max, num), 0)
          : 0;
      let counter = maxno + 1;

      setValue(`no`, counter);
    } catch (error) {
      console.error(
        "Failed to fetch stock adjustments",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  function handleRemove(index) {
    if (fields.length > 1) {
      remove(index);
    } else {
      toast.error("At least one row entry is required");
    }
  }
  const handleAddRow = () => {
    append({
      batch: "0",
      quantity: "0",
      unit: "",
      product: null,
    });
  };
  // useEffect(() => {
  //   if (mode === "add") {
  //     handleEntryNo();
  //     if (!isRowAdded && fields?.length === 0) {
  //       handleAddRow();
  //       setIsRowAdded(true);
  //     }
  //               // Set default warehouse if available
  //     const defaultWarehouse = getDefaultWarehouse();
  //     if (defaultWarehouse) {
  //       setValue("wareHouse", defaultWarehouse.value);
  //     }
  //   }
  //   handleBranchList();
  //   // handleProductsList();
  //   handleUnitList();
  // }, [branchsettings, warehouses]);

  useEffect(() => {
  if (mode === "add") {
    // Fetch next invoice number
    handleEntryNo();

    // Add first row if none exists
    if (!isRowAdded && fields?.length === 0) {
      handleAddRow();
      setIsRowAdded(true);
    }

    // Set default warehouse if available
    const defaultWarehouse = getDefaultWarehouse();
    if (defaultWarehouse) {
      setValue("wareHouse", defaultWarehouse.value);
    }
  }

  // Fetch branch list and units
  handleBranchList();
  handleUnitList();

  // Optionally, fetch products if you want
  // handleProductsList();
}, [branch, warehouses, branchsettings]);

  // function resetmodal() {
  //   if (mode === "edit" && data) {
  //     const resetData = {
  //       no: data?.invoiceNo,
  //       date: dayjs(data?.date),
  //       tobranch: data?.toBranch?.guid,
  //       remarks: data?.remarks,
  //       items: data?.invStockTransferDetails?.map((detail) => ({
  //         product: detail?.product?.guid,
  //         batch: detail?.batch,
  //         unit: detail?.unit?.guid,
  //         quantity: detail?.quantity,
  //       })),
  //     };
  //     reset(resetData);
  //   } else {
  //     reset();
  //     handleEntryNo();
  //   }
  // }
//   function resetmodal() {
//   if (mode === "edit" && data) {
//     const resetData = {
//       no: data?.invoiceNo,
//       date: dayjs(data?.date),
//       tobranch: data?.toBranch?.guid,
//       remarks: data?.remarks,
//       // Map items normally
//       items: data?.invStockTransferDetails?.map((detail) => ({
//         product: detail?.product?.guid,
//         batch: detail?.batch,
//         unit: detail?.unit?.guid,
//         quantity: detail?.quantity,
//       })),
//       // Fix warehouses
//       fromWarehouse: formattedWarehouses.find(
//         (wh) => wh.value.guid === data?.fromLocationID
//       )?.value || null,
//       toWarehouse: formattedWarehouses.find(
//         (wh) => wh.value.guid === data?.toLocationID
//       )?.value || null,
//     };
//     reset(resetData);
//   } else {
//     reset();
//     handleEntryNo();
//   }
// }
function resetmodal() {
  if (mode === "edit" && data) {
    const toBranchGuid = data?.toBranch?.guid;

    const resetData = {
      no: data?.invoiceNo,
      date: dayjs(data?.date),
      tobranch: toBranchGuid,
      remarks: data?.remarks,
      items: data?.invStockTransferDetails?.map((detail) => ({
        product: detail?.product?.guid,
        batch: detail?.batch,
        unit: detail?.unit?.guid,
        quantity: detail?.quantity,
      })),
      // From Warehouse (still based on current branch)
      fromWarehouse:
        getWarehousesByBranch(branch?.guid).find(
          (wh) => wh.value.guid === data?.fromLocationID
        )?.value || null,
      // To Warehouse (must use To Branch guid)
      toWarehouse:
        getWarehousesByBranch(toBranchGuid).find(
          (wh) => wh.value.guid === data?.toLocationID
        )?.value || null,
    };
    reset(resetData);
  } else {
    reset();
    const defaultWarehouse = getDefaultWarehouse(branch?.guid);
    if (defaultWarehouse) {
      setValue("fromWarehouse", defaultWarehouse.value);
    }
    handleEntryNo();
  }
}



  useEffect(() => {
    resetmodal();
  }, [warehouses, data]);

  // const handleProductsList = async () => {
  //   try {
  //     const response = productList || [];

  //     const formattedProducts = response?.map((product) => ({
  //       label: product.name,
  //       value: product.guid,
  //     }));
  //     setProducts(formattedProducts);
  //   } catch (error) {
  //     console.error(
  //       "Error fetching products",
  //       error?.response?.data?.Message || "something went wrong"
  //     );
  //   }
  // };

  // const handleFormSubmit = async (formdata) => {
  //   setloading(true);
  //   const objStockTrn = new InvStockTransfer();
  //   if (mode === "edit") {
  //     objStockTrn.guid = data?.guid;
  //     objStockTrn.id = data?.id;
  //   }
  //   objStockTrn.branch = branch;
  //   objStockTrn.date = formdata.date
  //     ? dayjs(formdata.date).format("YYYY-MM-DDTHH:mm:ss")
  //     : null;

  //   const tobranch = BranchByUser?.find(
  //     (e) => e.branch.guid === formdata.tobranch
  //   );
  //   objStockTrn.tobranch = tobranch.branch;

  //   objStockTrn.updatedUser = `{${userId?.id}}`;
  //   // objStockTrn.createdUser = `{${userId?.id}}`;
  //   objStockTrn.remarks = formdata.remarks || "";

  //   objStockTrn.invoiceNo = formdata.no ? String(formdata.no) : "0";

  //   const detailObj = formdata?.items?.map((e) => {
  //     let product;
  //     const productValue = e.product || e.product.value;

  //     product = productList?.find((item) => item.guid == productValue);
  //     const unit = unitList.find((item) => item.guid == e.unit);

  //     const detail = {
  //       product,
  //       unit,
  //       batch: e.batch || "",
  //       quantity: e.quantity,
  //       fromBranch: branch,
  //       tobranch: tobranch.branch,
  //     };

  //     return detail;
  //   });
  //   objStockTrn.invStockTransferDetails = detailObj;
  //   try {
  //     const response = await addEditStockTransfer(objStockTrn);
  //     if (response) {
  //       toast.success("Success");
  //       handleRefresh();
  //       handleClose();
  //     }
  //     setloading(false);
  //   } catch (error) {
  //     toast.error(error?.response?.data?.Message || "something went wrong");
  //     console.error(
  //       "Error handling :",
  //       error?.response?.data?.Message || "something went wrong"
  //     );
  //     setloading(false);
  //   }
  // };
const handleFormSubmit = async (formdata) => {
  setloading(true);
  const objStockTrn = new InvStockTransfer();

  // If editing an existing stock transfer
  if (mode === "edit") {
    objStockTrn.guid = data?.guid;
    objStockTrn.id = data?.id;
  }

  // Basic info
  objStockTrn.branch = branch;
  objStockTrn.date = formdata.date
    ? dayjs(formdata.date).format("YYYY-MM-DDTHH:mm:ss")
    : null;
  objStockTrn.invoiceNo = formdata.no ? String(formdata.no) : "0";
  objStockTrn.remarks = formdata.remarks || "";
  objStockTrn.updatedUser = `{${userId?.id}}`;

  // To Branch
  const tobranch = BranchByUser?.find(
    (e) => e.branch.guid === formdata.tobranch
  );
  objStockTrn.tobranch = tobranch?.branch || null;

  // ✅ From / To Location IDs
  const fromLocationID =
    formdata.fromWarehouse?.guid || formdata.fromWarehouse || null;
  const toLocationID =
    formdata.toWarehouse?.guid || formdata.toWarehouse || null;

  // Include also in root (if backend expects at root level)
  objStockTrn.fromLocationID = fromLocationID;
  objStockTrn.toLocationID = toLocationID;

  // Build details
  const detailObj = formdata?.items?.map((e) => {
    const productValue = e.product?.guid || e.product || null;
    const product = productList?.find((item) => item.guid === productValue);
    const unit = unitList?.find((item) => item.guid === e.unit);

    return {
      product,
      unit,
      batch: e.batch || "",
      quantity: e.quantity,
      fromBranch: branch,
      tobranch: tobranch?.branch || null,
      fromLocationID,
      toLocationID,
    };
  });

  objStockTrn.invStockTransferDetails = detailObj;

  try {
    const response = await addEditStockTransfer(objStockTrn);
    // success is a literal true (G-2) - a 200 "false" is a failure
    if (response?.data !== true) {
      toast.error(response?.data?.Message || "Not saved - please try again");
    } else {
      toast.success("Stock Transfer Saved Successfully");
      handleRefresh();
      handleClose();
    }
    setloading(false);
  } catch (error) {
    toast.error(error?.response?.data?.Message || "Something went wrong");
    console.error(
      "Error handling stock transfer:",
      error?.response?.data?.Message || "Something went wrong"
    );
    setloading(false);
  }
};

const selectedToBranch = watch("tobranch"); // guid of selected To Branch

  // react-select menus render into this node inside .si-term, so they pick
  // up the terminal's colour tokens like everything else
  const [menuHost, setMenuHost] = useState(null);
  const menuPortalTarget = menuHost;
  const siSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 11000 }),
    menu: (base) => ({ ...base, zIndex: 11000 }),
  };

  // view preferences only - theme, full screen, More row, visible columns
  const chrome = useTerminalChrome("stockTransfer", {
    batch: true,
  });
  const fromWarehouseName = watch("fromWarehouse")?.name;
  const toWarehouseName = watch("toWarehouse")?.name;
  const toBranchName = branchData?.find(
    (b) => b?.value === selectedToBranch
  )?.label;
  const qtyTotal = (fields || []).reduce(
    (sum, f, i) => sum + (Number(watch(`items[${i}].quantity`)) || 0),
    0
  );

  return (
    <div>
      <div
        className="modal fade show si-term si-term--txn"
        data-si-theme={chrome.theme}
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog si-dialog">
          <div className="modal-content si-content">
            <form
              className="si-form"
              onSubmit={handleSubmit(handleFormSubmit)}
            >
              <div className="si-grid">
                <div className="si-left">
                  {/* ============ COMMAND BAR ============ */}
                  <TermCmdBar
                    chrome={chrome}
                    title="Stock Transfer"
                    docNo={watch("no")}
                    state={
                      mode === "edit"
                        ? { key: "edit", label: "Editing" }
                        : { key: "new", label: "New" }
                    }
                    onBack={handleClose}
                  />
                  {/* entry number - the header shows it */}
                  <input
                    type="text"
                    className="si-offscreen"
                    tabIndex={-1}
                    aria-hidden="true"
                    {...register("no")}
                    required
                    disabled
                  />

                  {/* ============ HEADER FIELDS ============ */}
                  <section className="si-strip">
                    <div className="si-strip-row">
                      <div className="si-fld">
                        <label>
                          To Branch <span className="si-req">*</span>
                        </label>
                        <Controller
                          control={control}
                          name={`tobranch`}
                          render={({ field: { onChange, value } }) => (
                            <Select
                              classNamePrefix="react-select"
                              className="si-sel"
                              options={branchData}
                              isClearable
                              value={
                                branchData?.find(
                                  (option) => option?.value === value
                                ) || null
                              }
                              onChange={(selectedOption) =>
                                onChange(selectedOption?.value || null)
                              }
                              menuPortalTarget={menuPortalTarget}
                              menuPosition="fixed"
                              styles={siSelectStyles}
                              required
                            />
                          )}
                        />
                      </div>
                      {/* From Warehouse */}
{/* <div className="col-lg-4 col-sm-6 col-12">
  <div className="input-blocks">
    <label className="form-label">
      From Warehouse<span className="text-danger">*</span>
    </label>
    <Controller
      control={control}
      name="fromWarehouse"
      render={({ field: { onChange, value } }) => (
        <Select
          classNamePrefix="react-select"
          options={warehouses}
          isClearable
          value={warehouses.find((option) => option.value === value) || null}
          onChange={(selectedOption) =>
            onChange(selectedOption?.value || null)
          }
          styles={{
            menu: (provided) => ({
              ...provided,
              zIndex: 9999,
            }),
          }}
        />
      )}
    />
  </div>
</div> */}

{/* <div className="col-lg-4 col-sm-6 col-12">
  <div className="input-blocks">
    <label className="form-label">
      From Warehouse<span className="text-danger">*</span>
    </label>
             <Controller
                                          name="fromWarehouse"
                                          control={control}
                                          render={({ field }) => (
                                            <Select
                                              classNamePrefix="react-select"
                                              options={formattedWarehouses}
                                              isClearable
                                              placeholder="Select Warehouse"
                                              value={getSelectedWarehouseOption(field.value)}
                                              onChange={(option) => field.onChange(option.value)}
                                              styles={{
                                                menu: (provided) => ({ ...provided, zIndex: 9999 }),
                                              }}
                                            />
                                          )}
                                      />
  </div>
</div> */}
                      <div className="si-fld">
                        <label>
                          From Warehouse <span className="si-req">*</span>
                        </label>
                        <Controller
                          name="fromWarehouse"
                          control={control}
                          render={({ field }) => {
                            const filteredWarehouses = getWarehousesByBranch(branch?.guid);
                            return (
                              <Select
                                classNamePrefix="react-select"
                                className="si-sel"
                                options={filteredWarehouses}
                                isClearable
                                placeholder="Select Warehouse"
                                value={getSelectedWarehouseOption(field.value, branch?.guid)}
                                onChange={(option) => field.onChange(option.value)}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={siSelectStyles}
                              />
                            );
                          }}
                        />
                      </div>

{/* To Warehouse */}
{/* <div className="col-lg-4 col-sm-6 col-12">
  <div className="input-blocks">
    <label className="form-label">
      To Warehouse<span className="text-danger">*</span>
    </label>
    <Controller
      control={control}
      name="toWarehouse"
    render={({ field }) => (
                                            <Select
                                              classNamePrefix="react-select"
                                              options={formattedWarehouses}
                                              isClearable
                                              placeholder="Select Warehouse"
                                              value={getSelectedWarehouseOption(field.value)}
                                              onChange={(option) => field.onChange(option.value)}
                                              styles={{
                                                menu: (provided) => ({ ...provided, zIndex: 9999 }),
                                              }}
                                            />
                                          )}
    />
  </div>
</div> */}
                      <div
                        className={
                          selectedToBranch ? "si-fld" : "si-fld si-fld--ro"
                        }
                      >
                        <label>
                          To Warehouse <span className="si-req">*</span>
                        </label>
                        <Controller
                          name="toWarehouse"
                          control={control}
                          render={({ field }) => {
                            // Watch the selected To Branch
                            const selectedToBranch = watch("tobranch");

                            // Filter warehouses only if branch selected
                            const filteredWarehouses = selectedToBranch
                              ? getWarehousesByBranch(selectedToBranch)
                              : [];

                            return (
                              <Select
                                classNamePrefix="react-select"
                                className="si-sel"
                                options={filteredWarehouses}
                                isClearable
                                placeholder={
                                  selectedToBranch ? "Select Warehouse" : "Select To Branch first"
                                }
                                isDisabled={!selectedToBranch} // disable if no branch selected
                                value={
                                  selectedToBranch
                                    ? getSelectedWarehouseOption(field.value, selectedToBranch)
                                    : null
                                }
                                onChange={(option) => field.onChange(option.value)}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={siSelectStyles}
                              />
                            );
                          }}
                        />
                      </div>
                      <div className="si-fld si-fld--ro">
                        <label>
                          From Branch <span className="si-req">*</span>
                        </label>
                        <input
                          type="text"
                          className="si-in"
                          value={branch?.name}
                          disabled
                        />
                      </div>
                      <div className="si-fld">
                        <label>
                          Date <span className="si-req">*</span>
                        </label>
                        <Controller
                          control={control}
                          name="date"
                          render={({ field: { onChange, value } }) => (
                            <DatePicker
                              className="si-date"
                              value={value ? dayjs(value) : dayjs()}
                              format="DD-MM-YYYY"
                              onChange={(date) =>
                                onChange(
                                  date ? date.format("YYYY-MM-DD") : null
                                )
                              }
                            />
                          )}
                        />
                      </div>
                      <TermMoreToggle chrome={chrome} />
                    </div>

                    {/* kept mounted while collapsed - values still submit */}
                    <div
                      className="si-strip-row si-strip-row--more si-strip-row--auto"
                      hidden={!chrome.moreOpen}
                    >
                      <div className="si-fld si-fld--wide">
                        <label>Remarks</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="Note for this transfer"
                          {...register("remarks")}
                        />
                      </div>
                    </div>
                  </section>

                  {/* ============ LINES ============ */}
                  <section className="si-lines">
                    <TermColumns
                      chrome={chrome}
                      columns={[{ key: "batch", label: "Batch" }]}
                    >
                      <button
                        type="button"
                        className="si-iconbtn"
                        onClick={handleAddRow}
                      >
                        <Plus />
                        <span>Add line</span>
                      </button>
                      {!loading && (
                        <button
                          type="button"
                          className="si-iconbtn"
                          onClick={resetmodal}
                        >
                          <RotateCcw />
                          <span>Reset</span>
                        </button>
                      )}
                    </TermColumns>

                    <div className="si-tablewrap">
                      <table
                        className="si-table"
                        style={{
                          minWidth: `${chrome.tableWidth(504, {
                            batch: 80,
                          })}px`,
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "240px" }}>
                              Item <span className="si-req">*</span>
                            </th>
                            <th style={{ width: "70px" }}>
                              Unit <span className="si-req">*</span>
                            </th>
                            <th
                              className={chrome.colClass("batch")}
                              style={{ width: "80px" }}
                            >
                              Batch
                            </th>
                            <th className="n" style={{ width: "70px" }}>
                              Qty <span className="si-req">*</span>
                            </th>
                            <th
                              style={{ width: "44px" }}
                              aria-label="Line actions"
                            />
                          </tr>
                        </thead>
                        <tbody>
                          {fields?.map((field, index) => {
                            return (
                              <tr className="si-line" key={field.id}>
                                <td>
                                  <Controller
                                    control={control}
                                    name={`items[${index}].product`}
                                    rules={{
                                      required: "Product is required",
                                      validate: (value) => {
                                        const selectedProducts = watch(
                                          "items"
                                        )?.map((item) => item.product); // Get all selected products
                                        const isDuplicate =
                                          selectedProducts?.filter(
                                            (product) => product === value
                                          )?.length > 1;
                                        return (
                                          !isDuplicate ||
                                          "Duplicate product selected!"
                                        );
                                      },
                                    }}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Select
                                        classNamePrefix="react-select"
                                        className="si-itemsel"
                                        placeholder="Item name or code"
                                        options={formatedproductList}
                                        value={formatedproductList?.find(
                                          (option) => option.value === value
                                        )}
                                        onChange={(selectedOption) => {
                                          onChange(selectedOption.value);
                                          handleEachProductfetch(
                                            selectedOption,
                                            index
                                          );
                                        }}
                                        menuPortalTarget={menuPortalTarget}
                                        menuPosition="fixed"
                                        styles={siSelectStyles}
                                      />
                                    )}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.product && (
                                      <span className="si-err">
                                        {errors.items[index].product.message}
                                      </span>
                                    )}
                                </td>
                                <td data-label="Unit">
                                  <Controller
                                    control={control}
                                    name={`items[${index}].unit`}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Select
                                        classNamePrefix="react-select"
                                        className="si-unitsel"
                                        placeholder="—"
                                        options={unitData}
                                        value={unitData?.find(
                                          (option) => option.value === value
                                        )}
                                        onChange={(selectedOption) => {
                                          onChange(selectedOption.value);
                                        }}
                                        isDisabled={true}
                                      />
                                    )}
                                  />
                                </td>

                                <td className={chrome.colClass("batch")}>
                                  <input
                                    type="text"
                                    className="si-cellin si-cellin--text si-cellin--ro"
                                    tabIndex={-1}
                                    {...register(`items[${index}].batch`)}
                                    disabled
                                  />
                                </td>

                                <td className="n">
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="si-cellin"
                                    {...register(`items[${index}].quantity`, {
                                      required: "quantity is required",
                                      validate: (value) =>
                                        (!isNaN(value) && value > 0) ||
                                        "quantity must be a positive number",
                                    })}
                                    required
                                  />
                                  {errors.items &&
                                    errors.items[index]?.quantity && (
                                      <span className="si-err">
                                        {errors.items[index].quantity.message}
                                      </span>
                                    )}
                                </td>

                                <td>
                                  <div className="si-rowacts">
                                    <Link
                                      to="#"
                                      className="si-rowbtn si-rowbtn--del confirm-text"
                                      title="Remove line"
                                      aria-label="Remove line"
                                      onClick={() => handleRemove(index)}
                                    >
                                      <Trash2 />
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      {fields?.length === 0 && (
                        <div className="si-empty">
                          <p className="big">No lines yet</p>
                          <p>Press Add line to start the transfer.</p>
                        </div>
                      )}
                    </div>

                    <div className="si-lines-foot">
                      <span>
                        Lines <b>{fields?.length}</b>
                      </span>
                      <span>
                        Qty <b>{qtyTotal}</b>
                      </span>
                    </div>
                  </section>

                  {/* ============ STATUS BAR ============ */}
                  <TermStatusBar
                    context={[
                      fromWarehouseName,
                      branch?.name && toBranchName
                        ? `${branch.name} → ${toBranchName}`
                        : branch?.name,
                    ]}
                  />
                </div>

                {/* ============ RAIL ============ */}
                <aside className="si-rail">
                  <div className="si-rail-scroll">
                    <div className="si-card">
                      <div className="si-card-h">Transfer</div>
                      <div className="si-party">
                        <div className="nm">{branch?.name || "—"}</div>
                        <div className="meta">
                          {fromWarehouseName || "No warehouse selected"}
                        </div>
                      </div>
                      <div className="si-party">
                        <div className="nm">
                          → {toBranchName || "No branch selected"}
                        </div>
                        <div className="meta">
                          {toWarehouseName ||
                            (selectedToBranch
                              ? "No warehouse selected"
                              : "Pick a To Branch to start")}
                        </div>
                      </div>
                    </div>

                    <div className="si-card">
                      <div className="si-card-h">Summary</div>
                      <div className="si-tot">
                        <div className="si-tr">
                          <span className="l">Lines</span>
                          <span className="v">{fields?.length}</span>
                        </div>
                        <div className="si-tr">
                          <span className="l">Qty</span>
                          <span className="v">{qtyTotal}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {!loading && (
                    <div className="si-actions">
                      <button
                        className="si-btn si-btn--primary"
                        type="submit"
                      >
                        <Check />
                        <span>Save</span>
                      </button>
                    </div>
                  )}
                </aside>
              </div>
            </form>
          </div>
        </div>
        {/* react-select menus portal here so they inherit the .si-term tokens */}
        <div ref={setMenuHost} className="si-menu-host" />
      </div>
    </div>
  );
};
export default StockTransferModal;
